<template>
  <div class="configNetPage">
    <!-- 第一部分: 基础信息 -->
    <div class="section-box">
    <ul class="base-info">
      <li v-for="item in baseMsg" :key="item.key">
        <span class="label">{{ $t(item.text) }}：</span>
        <span class="value">
          <template v-if="item.key === 'url'">
            <template
              v-if="
                $attrs['sensorWay'] === 'bind' || $attrs['sensorWay'] === 'stop'
              "
            >
              {{
                rowData.scopeName +
                  '/' +
                  rowData.sceneName +
                  '/' +
                  rowData.carrierName
              }}
            </template>
            <template v-else>{{ rowData.scopeName }}</template>
          </template>
          <template
            v-else-if="item.key === 'type' || item.key === 'configStatus'"
          >
            {{ changeTextFn(item.key, rowData[item.key]) }}
          </template>

          <template v-else>{{ rowData[item.key] }}</template>
        </span>
      </li>
    </ul>
    </div>
    <!-- 第二部分: 配置参数 -->
    <div class="section-box" v-loading="loading">
      <el-form
        ref="form"
        :model="dioForm"
        :rules="rules"
        label-position="right"
        label-width="auto"
        label-suffix="："
      >
        <el-form-item :label="$t('device.channel_mask')" prop="channelMask">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.channelMask"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['channelMaskCurrent'] &&
                  dioForm['channelMaskCurrent'].change
              "
              >{{ dioForm['channelMaskCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['channelMaskCurrent']" style="color: red">{{
              dioForm['channelMaskCurrent'].modify
            }}</span>
          </template>
        </el-form-item>
        <el-form-item :label="$t('Ext Pan ID')" prop="extPanId">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.extPanId"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['extPanIdCurrent'] &&
                  dioForm['extPanIdCurrent'].change
              "
              >{{ dioForm['extPanIdCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['extPanIdCurrent']" style="color: red">{{
              dioForm['extPanIdCurrent'].modify
            }}</span>
          </template>
        </el-form-item>
        <el-form-item :label="$t('Join Attemp')" prop="channelPage">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.channelPage"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['channelPageCurrent'] &&
                  dioForm['channelPageCurrent'].change
              "
              >{{ dioForm['channelPageCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['channelPage']" style="color: red">{{
              dioForm['channelPageCurrent'].modify
            }}</span>
          </template>
        </el-form-item>
        <el-form-item :label="$t('device.transmit_power')" prop="transmitPower">
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.transmitPower"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['transmitPowerCurrent'] &&
                  dioForm['transmitPowerCurrent'].change
              "
              >{{ dioForm['transmitPowerCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['transmitPower']" style="color: red">{{
              dioForm['transmitPowerCurrent'].modify
            }}</span>
          </template>
        </el-form-item>
        <el-form-item
          :label="$t('device.in_net_interval')"
          prop="inNetInterval"
        >
          <el-input
            v-if="!isClickConfig"
            v-model.trim="dioForm.inNetInterval"
            style="width: 250px"
            maxlength="50"
            :placeholder="$t('public.please_enter')"
          />
          <template v-else>
            <span
              v-if="
                rowData['configStatus'] !== 2 &&
                  dioForm['inNetIntervalCurrent'] &&
                  dioForm['inNetIntervalCurrent'].change
              "
              >{{ dioForm['inNetIntervalCurrent'].current + '-->' }}</span
            >
            <span v-if="dioForm['inNetInterval']" style="color: red">{{
              dioForm['inNetIntervalCurrent'].modify
            }}</span>
          </template>
        </el-form-item>

      </el-form>
      <div class="form-actions" v-if="rowData['configStatus'] !== 1">
        <el-button v-if="isClickConfig" type="primary" @click="configISFn"
          >{{ $t('public.config') }}
        </el-button>
        <template v-else>
          <el-button type="primary" @click="cancelFn"
            >{{ $t('public.cancel') }}
          </el-button>
          <el-button type="primary" @click="configSave"
            >{{ $t('public.save') }}
          </el-button>
        </template>
      </div>
    </div>
    <!-- 第三部分: Command (只有存在16进制命令时才显示) -->
    <div class="section-box" v-if="baseContent.cmd">
      <el-form label-width="100px" label-position="right" label-suffix="：">
        <el-form-item :label="$t('public.command')">
          <span class="cmd-text">{{ baseContent.cmd }}</span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 第四部分: 配置列表 -->
    <div class="section-box" v-if="listArray.length">
    <div class="list">
      <div class="listPage" v-for="item in listArray" :key="item.id">
        <span>{{ $timetransition(item['logTime']) }}</span>
        <!-- 只能输网络参数 -->
        <span>{{ $t('integration.network_parameters') }}</span>
        <span>{{ configFn(item['stepCode']) }}</span>
        <el-button
          type="text"
          size="small"
          :title="$t('public.details')"
          icon="el-icon-tickets"
          @click="configDetailFn(item)"
        ></el-button>
      </div>
    </div>
    </div>
    <!-- 命令详情 -->
    <cmdDialog :title="title" :isShow.sync="isShow" :cmdObj="cmdObj" />
  </div>
</template>

<script>
import { relayGetNetConfig, relayUpdateNetConfig } from '@/api/modules/relay.js'
import { getConfigLogContent } from '@/api/modules/deviceUrl.js'
import cmdDialog from './children/cmdDialog.vue'
import { addNetRules } from '../../validate/addRules'
import {
  configStatusConvert,
  configStep,
  relayTypeConvert
} from '@/utils/convert'

export default {
  props: ['rowData'],
  components: {
    cmdDialog
  },
  computed: {
    rules () {
      const rules = addNetRules([
        'extPanId',
        'channelPage',
        'channelMask',
        'transmitPower',
        'inNetInterval'
      ])
      return rules
    }
  },
  data () {
    return {
      baseMsg: [
        {
          text: 'public.belong',
          key: 'url'
        },
        {
          text: 'device.relay_number',
          key: 'relayCode'
        },
        {
          text: 'public.config_status',
          key: 'configStatus'
        },

        {
          text: 'public.carrier',
          key: 'carrierName'
        },
        {
          text: 'public.type',
          key: 'type'
        }
      ],
      baseContent: {},
      dioForm: {
        extPanId: null,
        channelPage: null,
        channelMask: null,
        inNetInterval: null,
        transmitPower: null
      },
      listArray: [],
      isClickConfig: true,
      // 详情
      isShow: false,
      title: '',
      cmdObj: {},
      loading: false
    }
  },
  activated () {
    if (this.$attrs.sensorWay !== 'bind' && this.$attrs.sensorWay !== 'stop') {
      this.baseMsg.splice(-2, 1)
    }
    this.httpUrlFn()
  },
  methods: {
    configISFn () {
      this.isClickConfig = !this.isClickConfig
    },
    cancelFn () {
      this.isClickConfig = true
      this.clearValidate()
    },
    clearValidate () {
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    async configSave () {
      const flag = await this.justify()
      if (!flag) return
      this.loading = true
      const {
        extPanId,
        channelPage,
        channelMask,
        inNetInterval,
        transmitPower
      } = this.dioForm
      const query = {
        extPanId: extPanId,
        channelPage: channelPage,
        channelMask: channelMask,
        idList: [this.rowData.id],
        inNetInterval,
        transmitPower
      }
      relayUpdateNetConfig(query)
        .then(({ result, state }) => {
          if (result && state.code === 200) {
            this.$message.success($t('integration.update_successful'))
            this.httpUrlFn()
            this.isClickConfig = !this.isClickConfig
          } else {
            this.$message.error(state.msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    httpUrlFn () {
      relayGetNetConfig({ relayId: this.rowData.id })
        .then(({ result }) => {
          if (result) {
            if (result.content) {
              const JsonContent = JSON.parse(result.content)
              this.baseContent.cmd = JsonContent.cmd
              this.dioForm = {
                extPanId: JsonContent.item.ext_pan_id.modify,
                extPanIdCurrent: JsonContent.item.ext_pan_id,
                channelPage: JsonContent.item.channel_page.modify,
                channelPageCurrent: JsonContent.item.channel_page,
                channelMask: JsonContent.item.channel_mask.modify,
                channelMaskCurrent: JsonContent.item.channel_mask,
                transmitPower: JsonContent.item.transmit_power.modify,
                transmitPowerCurrent: JsonContent.item.transmit_power,
                inNetInterval: JsonContent.item.in_net_interval.modify,
                inNetIntervalCurrent: JsonContent.item.in_net_interval
              }
            }

            this.listArray = result.responseDeviceConfigLogList
          } else {
            // 默认值
            this.dioForm = {}
          }
        })
        .catch(() => {
          this.dioForm = {}
        })
    },
    changeTextFn (key, value) {
      if (key === 'type') {
        return this.$t(relayTypeConvert(value).title)
      } else {
        return this.$t(configStatusConvert(value).title)
      }
    },
    configFn (value) {
      return this.$t(configStep[value].title)
    },
    configDetailFn (row) {
      this.isShow = true
      this.title = `[${
        row.deviceName
      }][${$t('integration.network_parameters')}] ${$t('integration.configuration_details')}-[${this.$timetransition(row.logTime)}]`

      getConfigLogContent({ configLogId: row.id }, 'relay').then(
        ({ result }) => {
          if (result.content) {
            const JsonContent = JSON.parse(JSON.parse(result.content).content)

            this.cmdObj = {
              url: `${this.rowData.scopeName}`,
              name: this.rowData.code,
              configStatus: result.status,
              carrierName: this.rowData.carrierName,
              type: this.rowData.type,
              cmd: JsonContent.cmd,
              ...JsonContent.item
            }
          }
        }
      )
      // let JsonContent = '';
      // if (row.content) {
      //     JsonContent = JSON.parse(row.content)||{}
      // }
      // const JSONCONTENT = JSON.parse(JsonContent.content);
      // const { cmd, item } = JSONCONTENT;
      // this.cmdObj = Object.assign({}, this.rowData, {
      //     cmd,
      //     channelMask: item['channelMask'],
      //     channelPage: item['channelPage'],
      //     extPanId: item['extPanId'],
      //     step: row['step_code']
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.configNetPage {
  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .form-actions {
    text-align: right;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e4e7ed;
  }

  .base-info {
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: 10px;

    li {
      display: contents;
    }

    .label {
      text-align: right;
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }

    .value {
      line-height: 40px;
      color: #606266;
      font-size: 14px;
    }
  }

  .list {
    max-height: 200px;
    overflow: auto;
  }

  .listPage {
    height: 40px;
    width: 100%;
    margin-top: 15px;
    padding: 0 15px;
    box-sizing: border-box;
    border-radius: 2px;
    border: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .cmd-text {
    word-break: break-all;
    font-family: Consolas, Monaco, monospace;
    color: #303133;
  }
}
</style>
